import { useEffect, useRef } from "react";
import Button from "../../../form/Button";
import { useTranslation } from "react-i18next";

const ExportDropdown = ({ onExport, isOpen, onToggle }) => {
  const dropdownRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        if (isOpen) {
          onToggle(); // Close the dropdown
        }
      }
    };

    // Add event listener when dropdown is open
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Cleanup event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onToggle]);

  return (
    <div className="relative w-full md:w-auto" ref={dropdownRef}>
      <Button
        buttonFunction={onToggle}
        buttonIcon={"fas fa-download text-gray-600"}
        buttonIconRight={`fas text-xs fa-chevron-down transition-transform duration-200 text-gray-500 ${
          isOpen ? "rotate-180" : ""
        }`}
        buttonLabel={t("Export")}
        buttonClasses="px-4 py-2 border rounded-full border-gray-300 text-gray-700 bg-white hover:bg-gray-50 flex items-center gap-2 shadow-sm transition-all duration-200 hover:shadow-md hover:border-gray-400 w-full md:w-auto"
      />

      {isOpen && (
        <div className="absolute top-full mt-2 right-0 bg-white border border-gray-200 rounded-lg shadow-lg z-10 min-w-44 overflow-hidden">
          <div className="py-1">
            <Button
              buttonIcon={"fas fa-file-csv text-green-600 w-4"}
              buttonLabel={".CSV"}
              buttonFunction={() => onExport("csv")}
              buttonClasses="w-full px-4 py-3 text-gray-700 bg-white text-left hover:bg-gray-50 flex items-center gap-3 transition-colors duration-150 text-gray-700 hover:text-gray-900"
            />
            <div className="border-t border-gray-100"></div>
            <Button
              buttonIcon={"fas fa-file-excel text-green-700 w-4"}
              buttonLabel={".XLSX"}
              buttonFunction={() => onExport("xlsx")}
              buttonClasses="w-full px-4 py-3 text-gray-700 bg-white text-left hover:bg-gray-50 flex items-center gap-3 transition-colors duration-150 text-gray-700 hover:text-gray-900"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ExportDropdown;
